import {
  DISCOUNTCODES_REQUEST, DISCOUNTCODES_SUCCESS, DISCOUNTCODES_FAILURE,
  DISCOUNTCODE_REQUEST, DISCOUNTCODE_SUCCESS, DISCOUNTCODE_FAILURE,
  DISCOUNTCODE_ADD_REQUEST, DISCOUNTCODE_ADD_SUCCESS, DISCOUNTCODE_ADD_FAILURE,
  DISCOUNTCODE_UPDATE_REQUEST, DISCOUNTCODE_UPDATE_SUCCESS, DISCOUNTCODE_UPDATE_FAILURE,
  DISCOUNTCODE_DELETE_REQUEST, DISCOUNTCODE_DELETE_SUCCESS, DISCOUNTCODE_DELETE_FAILURE,
  DISCOUNTCODE_RESET
} from '../actions/discountCodes'
import {
  PARTNER_ASSIGN_DISCOUNTS_SUCCESS,
  PARTNER_REMOVE_DISCOUNTS_SUCCESS
} from '../actions/partners'

const INITIAL_STATE = {
  discountCodes: null,
  discountCodesNeedRefresh: false,
  discountCode: null,
  error: null,
  loading: false
}

const discountCodesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DISCOUNTCODES_REQUEST:
      return {
        ...state,
        discountCodes: null,
        error: null,
        loading: true
      }
    case DISCOUNTCODES_SUCCESS:
      return {
        ...state,
        discountCodes: action.response,
        discountCodesNeedRefresh: false,
        error: null,
        loading: false
      }
    case DISCOUNTCODES_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case DISCOUNTCODE_REQUEST:
      return {
        ...state,
        error: null,
        loading: true
      }
    case DISCOUNTCODE_SUCCESS:
      return {
        ...state,
        discountCode: action.response,
        error: null,
        loading: false
      }
    case DISCOUNTCODE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case DISCOUNTCODE_ADD_REQUEST:
      return {
        ...state,
        error: null,
        loading: true
      }
    case DISCOUNTCODE_ADD_SUCCESS:
      return {
        ...state,
        discountCode: action.response,
        discountCodesNeedRefresh: true,
        error: null,
        loading: false
      }
    case DISCOUNTCODE_ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case DISCOUNTCODE_UPDATE_REQUEST:
      return {
        ...state,
        error: null,
        loading: true
      }
    case DISCOUNTCODE_UPDATE_SUCCESS:
      return {
        ...state,
        discountCode: action.response,
        discountCodesNeedRefresh: true,
        error: null,
        loading: false
      }
    case DISCOUNTCODE_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case DISCOUNTCODE_DELETE_REQUEST:
      return {
        ...state,
        error: null,
        loading: true
      }
    case DISCOUNTCODE_DELETE_SUCCESS:
      return {
        ...state,
        discountCodesNeedRefresh: true,
        error: null,
        loading: false
      }
    case DISCOUNTCODE_DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case DISCOUNTCODE_RESET:
      return {
        ...state,
        discountCode: null,
        error: null,
        loading: false
      }
    case PARTNER_ASSIGN_DISCOUNTS_SUCCESS:
      return {
        ...state,
        discountCodesNeedRefresh: true
      }
    case PARTNER_REMOVE_DISCOUNTS_SUCCESS:
      return {
        ...state,
        discountCodesNeedRefresh: true
      }
    default:
      return state
  }
}

export default discountCodesReducer